"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandlerType = void 0;
var EventHandlerType;
(function (EventHandlerType) {
    EventHandlerType[EventHandlerType["ApplyEffect"] = 1] = "ApplyEffect";
    EventHandlerType[EventHandlerType["DispatchAction"] = 2] = "DispatchAction";
    EventHandlerType[EventHandlerType["RegisterEventHandler"] = 3] = "RegisterEventHandler";
    EventHandlerType[EventHandlerType["CancelEventHandlers"] = 4] = "CancelEventHandlers";
    EventHandlerType[EventHandlerType["CancelEffects"] = 5] = "CancelEffects";
    EventHandlerType[EventHandlerType["CustomScript"] = 6] = "CustomScript";
    EventHandlerType[EventHandlerType["TriggerAi"] = 7] = "TriggerAi";
    EventHandlerType[EventHandlerType["ApplyEffectToDamager"] = 8] = "ApplyEffectToDamager";
    EventHandlerType[EventHandlerType["TriggerAdventure"] = 9] = "TriggerAdventure";
    // Common Storage Values
    EventHandlerType[EventHandlerType["SetLocalValue"] = 10] = "SetLocalValue";
    EventHandlerType[EventHandlerType["UnsetLocalValue"] = 11] = "UnsetLocalValue";
    EventHandlerType[EventHandlerType["SetPermanentValue"] = 12] = "SetPermanentValue";
    EventHandlerType[EventHandlerType["UnsetPermanentValue"] = 13] = "UnsetPermanentValue";
    // Numbers
    EventHandlerType[EventHandlerType["IncrementLocalNumber"] = 14] = "IncrementLocalNumber";
    EventHandlerType[EventHandlerType["DecrementLocalNumber"] = 15] = "DecrementLocalNumber";
    EventHandlerType[EventHandlerType["IncrementPermanentNumber"] = 16] = "IncrementPermanentNumber";
    EventHandlerType[EventHandlerType["DecrementPermanentNumber"] = 17] = "DecrementPermanentNumber";
    EventHandlerType[EventHandlerType["RemoveActor"] = 18] = "RemoveActor";
    EventHandlerType[EventHandlerType["RecurringDamage"] = 19] = "RecurringDamage";
    EventHandlerType[EventHandlerType["DispatchRandomAction"] = 20] = "DispatchRandomAction";
    EventHandlerType[EventHandlerType["UnsafeDispatchAction"] = 21] = "UnsafeDispatchAction";
})(EventHandlerType = exports.EventHandlerType || (exports.EventHandlerType = {}));
